import * as React from 'react';
import { VStack, Box } from '@chakra-ui/react';
import { SvgIcon } from 'core/ui-next';
import { useOverlayExecutor } from 'core/ui-next/modal';
import { useClickWithFeedback } from './useClickWithFeedback';

export function SidebarButton({ text, icon, action, selectedMode }: { text: string, icon: SvgIcon, action: () => void, selectedMode?: boolean }) {

	const { execute } = useOverlayExecutor();

	const onClick = React.useCallback(() => execute({
		overlay: 'on-start',
		waitForPendingRequests: true,
		action: async () => action()
	}), [execute, action]);

	return <Box w={'full'} cursor={'pointer'} touchAction={'manipulation'} bg={selectedMode ? 'blue.800' : 'transparent'}
		{...useClickWithFeedback(onClick)}
	>
		<VStack gap={'1'} paddingX='2' maxWidth={20}>
			<SvgIcon src={icon} h='8' w='8' />
			<Box lineClamp='2' fontWeight={'normal'} fontSize={'xs'} textAlign={'center'}>{text}</Box>
		</VStack>
	</Box>;
}